import { showLoader, hideLoader } from '../../../Shared/Loader';
import { Ajax } from '../../../components/Ajax';
import { ApiUrl } from '../../../project/Defines';
import { message } from 'antd';
import { dispatchCustomEvent } from '../../../project/utilities';
import FileSaver from 'file-saver';

const loaderName = 'TRANSLATION_FILE_UPLOAD_LOADER';
const exportLoaderName = 'TRANSLATION_FILE_EXPORT_LOADER';

export function TranslationImport(data, listUpdateEvent, successCallback) {
    showLoader(loaderName);

    Ajax.post({
        url: ApiUrl.SalesNetworkUITranslationsImport,
        data: {
            file: data && data.file
        },
        success: (response) => {
            if (!response.HasError) {
                successCallback && successCallback(response);
                dispatchCustomEvent(listUpdateEvent);
                hideLoader(loaderName);
            } else {
                message.error(response.message);
                hideLoader(loaderName);
            }
        }
    });
}

export function TranslationExport(showEmpty) {
    showLoader(exportLoaderName);

    Ajax.download({
        url: ApiUrl.SalesNetworkUITranslationsExport,
        data: {
            filterData: JSON.stringify({show_empty: showEmpty})
        },
        //autoDownload: false,
        success: (blob) => {
            FileSaver.saveAs(blob, "Translation.xlsx");
            hideLoader(exportLoaderName);
        },
        error: () => {
            hideLoader(exportLoaderName);
        }
    });
}

export function ThercodimTranslationExport(showEmpty) {
    showLoader(exportLoaderName);

    Ajax.download({
        url: ApiUrl.ThercodimExportData,
        data: {
            filterData: JSON.stringify({show_empty: showEmpty})
        },
        success: (blob) => {
            FileSaver.saveAs(blob, "Translation.xlsx");
            hideLoader(exportLoaderName);
        },
        error: () => {
            hideLoader(exportLoaderName);
        }
    });
}